// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"9cc491b8","270":"1ff0fe0a","276":"d8776d66","386":"faa46664","409":"245be947","453":"926f0775","736":"0be75fed","915":"4e3a0ca2","987":"f9f41d31"}[chunkId] + ".chunk.js";
};